import Localizr from '../utils/Localizr';
import Preloader from '../utils/Preloader';

import './carol.scss';
import ImageGallery from '../app/components/ImageGallery.NoTween';

class Carol {
  constructor() {
    this.layout();
    // initButtons();
    this.initGallery();
  }

  layout() {
    document.querySelector('#shell').appendChild(Localizr.template(Preloader.getFile('carol-template'), {}));

    Localizr.parseObjectList(settings.sections.carol.items);
  }

  initButtons() {}

  preenter() {}

  enter() {
    // trackPageView('Carol');
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  onEnterStart() {
    resizer.force();
  }

  onEnterComplete() {
    SITE.utils.sequencer.next();
  }

  exit() {
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  postExit() {}

  onResize(sizes) {}

  initGallery() {
    new ImageGallery({
      shell: document.querySelector('.carol-gallery-images'),
      lastBtn: document.querySelector('.carol-back'),
      nextBtn: document.querySelector('.carol-next'),
      images: settings.sections.carol.gallery,
      slideEnabled: false,
    });
  }
}

export default Carol;
